
// import { Caption, Title } from '../../../atom/elements/Typography';
// import getContents from '@store/Landing/getContents'

import styled from 'styled-components'
// const Container = styled.div`
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     @media (max-width:600px){
//         margin-top: 5em;
//     }
// `;
const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5em;
  @media (max-width: 600px) {
    align-items: center;
    // width: 90%;
    flex-direction: column;
  }
`
const GroupLink = styled.a`
  align-items: center;
  background: #fff;
  border: 4px solid #ececec;
  border-radius: 1em;
  cursor: pointer;
  color: inherit;
  display: flex;
  height: 119px;
  margin: 5em;
  padding: 1em;
  text-decoration: none;
  width: 552px;
  div.row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  &:hover {
    border: 4px solid var(--bg-primary);
  }
  @media (max-width: 600px) {
    margin: 1.5em 0;
    width: 90%;
    height: 100px;
  }
`
const GroupIcon = styled.img`
  margin: 0 2em;
  @media (max-width: 600px) {
    width: 50px;
  }
`
const GroupTitle = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  @media (max-width: 600px) {
    font-size: 18px;
  }
`
const GroupCaption = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  color: #01d451;
  @media (max-width: 600px) {
    font-size: 14px;
  }
`

function Containers ({ contents }) {
  return (
    <ButtonGroup>
      {[
        {
          icon: '/media/logo/gmail.png',
          title: 'Email',
          subtitle: 'support@sellon.net',
          link: 'mailto:support@sellon.net?subject=Mail from Our Site'
        },
        {
          icon: '/media/logo/whatsapp.png',
          title: 'WhatsApp',
          subtitle: '+65 8856 2024',
          link: 'https://api.whatsapp.com/send?phone=6588562024'
        }
      ].map((contact) => (
        <GroupLink href={contact.link} target="_blank" rel="noreferrer">
          <GroupIcon src={contact.icon} alt={`icon ${contact.title}`} />
          <div className="row">
            <GroupTitle>{contact.title}</GroupTitle>
            <GroupCaption>{contact.subtitle}</GroupCaption>
          </div>
        </GroupLink>
      ))}
    </ButtonGroup>
  )
}

export default Containers
